<div>
  <h3 class="text-lg font-medium text-primary-text">
    {{ labelKey() | translate }}
  </h3>
  <div class="text-secondary-text">
    <ng-content></ng-content>
  </div>
</div>
